import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

type BlotterRegistrationQueryPayload = {
  dataStreamId: string;
  showMyMainDeals: boolean;
};

export const register = (builder: WebapiEndpointBuilder) => {
  return builder.mutation({
    query: (body: BlotterRegistrationQueryPayload) => ({
      url: '/blotter/register',
      method: 'POST',
      body,
    }),
  });
};
